export enum Order {
    ASC,
    DESC,
    NONE
}
